import React from 'react'
import { GoogleMap, InfoWindow, useJsApiLoader } from '@react-google-maps/api'
import { useTranslation } from 'react-i18next'
import { calculateZoom, getGeolocation } from '../../../../services/locationMap/locationMapService'
import { ContentStateInterface, GeoCoordinates } from '../../../../@types/types'
import { GOOGLE_MAP_API_KEY } from '../../../../config'
import { Marker } from './Marker'

const containerStyle = {
  width: '100%',
  height: '200px',
}

export interface LocationMapProps {
  insertionData: ContentStateInterface
  geoCoordinates: GeoCoordinates
}

const options: google.maps.MapOptions = {
  draggable: false,
  disableDoubleClickZoom: true,
  keyboardShortcuts: false,
  panControl: false,
  rotateControl: false,
  scaleControl: false,
  scrollwheel: false,
  streetViewControl: false,
  zoomControl: false,
  mapTypeControl: false,
  clickableIcons: false,
  mapId: 'location-map-id',
}
const markerIcon = document.createElement('img')
markerIcon.src =
  'https://www.static-immobilienscout24.de/statpic/map/img/2ec9c4accd47fb1703a61369c7a8776d_POI_rebrand.svg'

export const markerOption: google.maps.marker.AdvancedMarkerElementOptions = {
  content: markerIcon,
}
const LocationMap: React.FC<LocationMapProps> = ({ insertionData, geoCoordinates }) => {
  const { t } = useTranslation()
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    language: 'de',
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
    libraries: ['marker'],
  })

  const geolocation = getGeolocation(geoCoordinates, insertionData)
  const showMarker = !geolocation.isManual && !insertionData.hideStreetAndStreetNumber
  const position = { lat: geolocation.latitude, lng: geolocation.longitude }
  const zoom = calculateZoom(insertionData, geolocation.isManual)
  const infoWindowText = geolocation.isManual
    ? insertionData.manualQuarter?.label
    : insertionData.postcode + ' ' + insertionData.city

  return (
    <div style={{ ...containerStyle }}>
      {isLoaded && (
        <GoogleMap
          zoom={zoom}
          mapContainerStyle={containerStyle}
          center={position}
          options={options}
          id='location-map-id'
        >
          {showMarker ? (
            <Marker
              options={markerOption}
              position={position}
              title={t('wizard.screen.nationalAddress.locationMap.marker', 'Marker')}
            />
          ) : (
            <InfoWindow position={position}>
              <div>
                <span className='font-body-medium-bold'>{t('wizard.navigation.label.address', 'Address')} </span>
                <span>{infoWindowText}</span>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      )}
    </div>
  )
}

export default LocationMap
